<template>
  <div class="ps-4 ms-2 me-4 mb-0 pb-0">
    <div class="row d-flex justify-content-center">
      <form @submit.prevent="submitForm" ref="submitFormModal">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-md-6 p-2">
              <label for="fantasyName">Nombre Interno:</label>
              <input v-model="company.fantasy_name" id="fantasyName" class="form-control" placeholder="Fantasy Name" disabled/>
            </div>
            <div class="col-md-6 p-2">
              <label for="fullName">Nombre de la empresa:</label>
              <input v-model="company.full_name" id="fullName" class="form-control" placeholder="Full Name" disabled/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 p-2">
              <label for="lineOfBusiness">Giro:</label>
              <input v-model="company.line_of_business" id="lineOfBusiness" class="form-control" placeholder="Line of Business" disabled/>
            </div>
            <div class="col-md-6 p-2">
              <label for="identificationNumber">Rut:</label>
              <input v-model="company.identification_number" id="identificationNumber" class="form-control" placeholder="Identification Number" disabled/>
            </div>
          </div>
        </div> 
        <div class="col-lg-12">
          <div class="row">
            <div class="col-md-6 p-2">
              <label for="phone">Teléfono:</label>
              <input v-model="company.phone" id="phone" class="form-control" placeholder="Phone" disabled/>
            </div>
            <div class="col-md-6 p-2">
              <label for="addressStreet">Dirección:</label>
              <input v-model="company.address.street" id="addressStreet" class="form-control" placeholder="Address Street" disabled/>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="row">
            <div class="col-md-6 p-2">
              <label for="contactName">Nombre:</label>
              <input v-model="contact.name" id="contactName" class="form-control" placeholder="Contact Name" disabled/>
            </div>
            <div class="col-md-6 p-2">
              <label for="contactEmail">Email:</label>
              <input v-model="contact.email" id="contactEmail" class="form-control" placeholder="Contact Email" disabled/>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="row">
            <div class="col-md-6 p-2">
              <label for="contactPhone">Teléfono:</label>
              <input v-model="contact.phone_1" id="contactPhone" class="form-control" placeholder="Contact Phone" disabled/>
            </div>
            <div class="col-md-6 p-2">
              <label for="mapZoom">Map Zoom:</label>
              <input v-model="map.zoom" id="mapZoom" class="form-control" placeholder="Map Zoom" disabled/>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="row">
            <div class="col-md-6 p-2">
              <label for="mapLongitude">Map Longitude:</label>
              <input v-model="map.longitude" id="mapLongitude" class="form-control" placeholder="Map Longitude" disabled/>
            </div>
            <div class="col-md-6 p-2">
              <label for="mapLatitude">Map Latitude:</label>
          <input v-model="map.latitude" id="mapLatitude" class="form-control" placeholder="Map Latitude" disabled/>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  
  <ModalComponent ref="modalRef" />
</template>

<script>
import ModalComponent from '../utils/modal.vue';

export default {
  name: 'CreateFormComponent',
  components: { ModalComponent },
  data() {
    return {
      company: {
        fantasy_name: '',
        full_name: '',
        line_of_business: '',
        identification_number: '',
        phone: '', 
        address: {
          street: '',
          number: '',
          apartment: '',
          city: '',
          country: '',
          raw_address: ''
        },
      },
      contact: {
        name: '',
        email: '',
        phone_1: '',
        address: {
          city: '',
          country: '',
          raw_address: ''
        }
      },
      map: {
        zoom: '',
        longitude: '',
        latitude: ''
      },
      enterpriseName: '',
      pwd: '',
      json : []
    };
  },
  mounted() {
    this.setData(); 
  },  
  methods: {
    setData() {
  
      const data = localStorage.getItem('data');
      this.json = JSON.parse(data);

      this.company = this.json.company;
      this.contact = this.json.contact;
      this.map = this.json.map;

      localStorage.setItem('enterpriseName', this.json.company.fantasy_name)
    },
  },
};
</script>
<style>
 .modal.show .modal-dialog{
    margin-top: 70px !important;
    margin-bottom: 0 !important;
    margin-left: 550px;
  }
</style>
